import { useMemo } from "react";

import { useSearchParams } from "react-router-dom";

import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";

export default function ShopifyIntegration() {
  const [searchParams] = useSearchParams();

  const success = searchParams.get("success") === "true" ? true : false;
  const urlMessage = searchParams.get("message");

  const icon = useMemo(
    () =>
      success ? (
        <CheckCircleIcon className="h-32 w-32 text-green-600" />
      ) : (
        <XCircleIcon className="h-32 w-32 text-red-600" />
      ),
    [success]
  );

  const title = useMemo(
    () =>
      success
        ? "Successfully Authenticated Shopify!"
        : "Failed to Authenticate Shopify!",
    [success]
  );

  const message = useMemo(
    () =>
      success
        ? "You may now close this tab"
        : `Reason: ${urlMessage} - please try again, if the issue persists, please contact support`,
    [success, urlMessage]
  );

  return (
    <div className="bg-gray-100 h-screen flex justify-center items-start">
      <div className="w-1/2 p-4 border rounded-lg bg-white  mt-[12vh]">
        <div className="flex flex-col items-center">
          <h1 className="text-2xl font-medium my-4">{title}</h1>
          {icon}
        </div>
        <div className="flex justify-center my-4">
          <p className="text-sm font-light text-gray-700">{message}</p>
        </div>
      </div>
    </div>
  );
}
